import React from "react";
import Navigation from "./components/Navigation";
import "./index.css";
import { remote_url } from "./utils/CommonFunction";

function App() {
  const queryParameters = new URLSearchParams(window.location.search);
  let token = queryParameters.get("token");

  try {
    token = queryParameters.get("token").replaceAll(" ", "+");
  } catch (err) {
    token = null;
  }

  var path = window.location.pathname;
  // var id = path.replace("/", "");

  return (
    // <MuiThemeProvider>
    <div>
      <Navigation user_id={token} />
    </div>
    // </MuiThemeProvider>
  );
}

export default App;
